import React, { Component } from "react";
import { FiCast, FiLayers, FiUsers, FiMonitor } from "react-icons/fi";
import { withTranslation } from "react-i18next";

const service8 = `${process.env.PUBLIC_URL}/assets/images/gp_images/enjoy-loyalty-card.webp`
const service9 = `${process.env.PUBLIC_URL}/assets/images/gp_images/keep-up-with-eco-positive-info.webp`
const service10 = `${process.env.PUBLIC_URL}/assets/images/gp_images/keep-an-eye-on-your-eco-journey.webp`
const service11 = `${process.env.PUBLIC_URL}/assets/images/gp_images/enjoy-the-eco-positive-community.webp`
const service12 = `${process.env.PUBLIC_URL}/assets/images/gp_images/invite-your-friends.webp`
const service13 = `${process.env.PUBLIC_URL}/assets/images/gp_images/share-with-your-network.webp`
const service14 = `${process.env.PUBLIC_URL}/assets/images/gp_images/keep-your-private-data-safe.webp`

const MobileFunctionList2 = [
     {
        icon: <img className="service-logo m-0" src={service8} alt="enjoy-loyalty-card"/>,
        title: "Enjoy loyalty card",
        description: ""
    },
    {
        icon: <img className="service-logo m-0" src={service9} alt="keep-up-with-eco-positive-info"/>,
        title: "Keep up with eco-positive info",
        description: ""
    },
    {
        icon: <img className="service-logo m-0" src={service10} alt="keep-an-eye-on-your-eco-journey"/>,
        title: "Keep an eye on your eco-journey",
        description: ""
    },
    {
        icon: <img className="service-logo m-0" src={service11} alt="enjoy-the-eco-positive-community"/>,
        title: "Enjoy the eco-positive community",
        description: ""
    },
     {
        icon: <img className="service-logo m-0" src={service12} alt="invite-your-friends"/>,
        title: "Invite your friends",
        description: ""
    },
    {
        icon: <img className="service-logo m-0" src={service13} alt="share-with-your-network"/>,
        title: "Share with your network",
        description: ""
    },
    {
        icon: <img className="service-logo m-0" src={service14} alt="keep-your-private-data-safe"/>,
        title: "Keep your private data safe",
        description: ""
    },
]


class MobileFunctionList2Component extends Component {
    render() {
        const { column } = this.props;
        const ServiceContent = MobileFunctionList2.slice(0, this.props.item);
        const { t } = this.props;

        return (
            <React.Fragment>
                <div className="row service-main-wrapper">
                    {ServiceContent.map((val, i) => (
                        <div className={`${column}`} key={i}>
                            <div className="service service__style--2 text-left border-2px-solid-E6EAEE">
                                <div className="icon_service" style={{gap: "20px"}}>
                                   {val.icon}
                                    <div className="text-left" style={{ width: "calc(100% - 20px)"}}>
                                        <p className="item-title-large-blue">{t(val.title)}</p>
                                        <p className="item-description-large text-gray-small">{val.description}</p>
                                    </div>
                                   
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </React.Fragment>
        )
    }
}
export default withTranslation()(MobileFunctionList2Component);
